SupportMainContentWrapperView = require('../main_content_view')
SupportV2CurrentOrderView = require('../order_related/v2_current_order_view')
SupportStepActionsView = require('../step_actions_view')
SupportV2SelectDifferentOrderMenuView = require('../order_related/v2_select_different_order_menu_view')
SupportProgressBarView = require('../progress_bar_view')
SupportUtilsHelper = require('../../helpers/utils')
SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw')
SupportHelpWizardController = require('../../helpWizardController')
SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportV2StepOneView extends Backbone.View
  className: 'v2 step-one horizontal'

  initialize: ->
    @id = 1
    @I18nScope = 'modules.support'
    Groupon.Support.Email = {}
    @stepActions = new SupportStepActionsView
      template: SupportStepOneActionsTemplate
    @mainContentWrappper = new SupportMainContentWrapperView
    @createSubViews()

  resetContentModelParams: ()->
    if Groupon.Support.ContentModel?
      Groupon.Support.ContentModel.escalateToMerchant = false
      Groupon.Support.ContentModel.isRefundEligible = false

  renderOrderDetails: ()->
    window.hideFooterLinks()
    @resetContentModelParams()
    @mainContentWrappper.render( (contentWrapper)=>
      @renderProgressBar(contentWrapper)
      @renderSelectDifferentOrderDetailMenu(contentWrapper)
      @renderCurrentOrder(contentWrapper)
    )
    @$el.html(@mainContentWrappper.el)
    @renderOrderDetailsStepActions()
    @hideComponents()

  renderSelectDifferentOrderListingMenu: (contentWrapper)->
    @selectDifferentOrderMenu.renderOrderListing()
    contentWrapper.append(@selectDifferentOrderMenu.el)

  renderSelectDifferentOrderDetailMenu: (contentWrapper)->
    @selectDifferentOrderMenu.renderDetails()
    contentWrapper.append(@selectDifferentOrderMenu.el)

  renderCurrentOrder: (contentWrapper)->
    @currentOrderView.render()
    contentWrapper.append(@currentOrderView.el)

  hideComponents: ->
    SupportUtilsHelper.hideFloatingBoldChat()
    SharedWidgetLayoutView.hideWidgets()

  close: ->
    @$el.empty()

  render: (params = {}) ->
    {order} = params
    showLoading(@$el)
    unless Groupon.Support.OrdersCollection.hasOrders()
      @initOrdersFetch()
    else if order
      @getOrderDetails(order)
    else
      @renderOrderListing()

  initOrdersFetch:() ->
    _successCb = (orders) =>
      @myGrouponSuccessCallback(orders)
    _errorCb = () =>
      @loadOrderErrorCallback()
    if Groupon.Support.currentOrdersFilter.iterator.hasNext()
      Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb)
    else
      _errorCb()

  myGrouponSuccessCallback: (orders) ->
    if orders?.length > 0
      if window.orderIdFromMyGroupons?
        _successCb = (orderDetails) =>
          @getOrderMetaData(orderDetails)
        _errorCb = () =>
          @loadOrderErrorCallback()
        Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb)
      else
        @renderOrderListing()
    else if Groupon.Support.currentOrdersFilter.iterator.hasNext()
      @initOrdersFetch()
    else
      @noOrdersView()

  getOrderDetails: (orderSummary) ->
    _successCb = (orderDetails) =>
      @getOrderMetaData(orderDetails)
    params =
      order: orderSummary
    Groupon.Support.OrderModel.getOrderDetails params, _successCb, _successCb

  getOrderMetaData: (orderDetails) ->
    SupportHelpWizardController.changeCurrentOrder(orderDetails)
    if orderDetails?
      _successCb = (order) =>
        @handleNormalAndMyGrouponsFlow(order)
      _errorCb = () =>
        SupportHelpWizardController.changeCurrentOrder(null)
        @loadOrderDetailsErrorCallback()
      Groupon.Support.MAXINDEX = 3
      Groupon.Support.ORDER_NOT_LISTED = false
      Groupon.Support.NOT_ORDER_RELATED = false
      params =
        order: orderDetails
      Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb)

  handleNormalAndMyGrouponsFlow: (order)->
    if window.selectOrderFromMygroupons
      SupportHelpWizardController.stepTwo()
    else
      @renderOrderDetails()

  loadOrderErrorCallback: ->
    SupportHelpWizardController.abruptStepTwoFlow()

  loadOrderDetailsErrorCallback: ->
    SupportHelpWizardController.abruptStepTwoFlow()

  noOrdersView: ->
    SupportHelpWizardController.abruptStepTwoFlow()

  renderOrderListing: () ->
    Groupon.Support.MAXINDEX = 3
    window.hideFooterLinks()
    @mainContentWrappper.render( (contentWrapper)=>
      @renderProgressBar(contentWrapper)
      @renderSelectDifferentOrderListingMenu(contentWrapper)
    )
    @$el.html(@mainContentWrappper.el)
    @hideComponents()

  createSubViews: () ->
    @progressBar = new SupportProgressBarView
    @selectDifferentOrderMenu = new SupportV2SelectDifferentOrderMenuView()
    @currentOrderView = new SupportV2CurrentOrderView()

  renderProgressBar: (contentWrapper)->
    @progressBar.render()
    contentWrapper.append(@progressBar.el)
    contentWrapper.append("<br>")

  renderOrderDetailsStepActions: ->
    @stepActions.render()
    @$el.append(@stepActions.el)

module.exports = SupportV2StepOneView
